import FontIcon from './components/font-icon'   //引入组件
import './css/icon-font/iconfont.css'   //引入css
// import HelloWorld from './components/HelloWorld'   //引入组件
const helloWorld = {
  install (Vue, options) {
    // Vue.component(HelloWorld.name, HelloWorld);
    Vue.component(FontIcon.name, FontIcon) //全局组件
  }
}

export default helloWorld  //导出



// WEBPACK FOOTER //
// ./src/index.js